import ListView from '../../../components/listView/ListView'
import Page from '../../../components/pageView/Page'
import WidgetPage from '../../../components/widgetPage/WidgetPage'

const routesService = [
    {
        path: "/service",
        element: WidgetPage,
        props: { type: 'service', draggable: false, resizable: false }
    },
    // Service Planning
    {
        path: "/service/planning",
        element: Page,
        props: { type: "serviceTicketPlannerPage", options: { mode: "view", load: false } }
    },
    // Service Settings
    {
        path: "/service/settings",
        element: Page,
        props: { type: "serviceSettingsPage", options: { mode: "edit", load: true, onMount: 'collapse' } }
    },
    // Service Skills
    { path: "/service/serviceSkill", element: ListView, props: { type: "serviceSkillList" } },
    { path: "/service/serviceSkill/new", element: Page, props: { type: "serviceSkillPage", options: { mode: "new", load: false } } },
    { path: "/service/serviceSkill/:id", element: Page, props: { type: "serviceSkillPage", options: { mode: "edit", load: true, onMount: 'collapse' } } },
    // Service Locations
    { path: "/service/serviceLocation", element: ListView, props: { type: "serviceLocationList" } },
    { path: "/service/serviceLocation/new", element: Page, props: { type: "serviceLocationPage", options: { mode: "new", load: false } } },
    { path: "/service/serviceLocation/:id", element: Page, props: { type: "serviceLocationPage", options: { mode: "edit", load: true, onMount: 'collapse' } } },
    // Assets
    { path: "/service/asset", element: ListView, props: { type: "assetList" } },
    { path: "/service/asset/new", element: Page, props: { type: "assetPage", options: { mode: "new", load: false } } },
    { path: "/service/asset/:id", element: Page, props: { type: "assetPage", options: { mode: "edit", load: true, onMount: 'collapse' } } },
    // Service Types
    { path: "/service/serviceType", element: ListView, props: { type: "serviceTypeList" } },
    { path: "/service/serviceType/new", element: Page, props: { type: "serviceTypePage", options: { mode: "new", load: false } } },
    { path: "/service/serviceType/:id", element: Page, props: { type: "serviceTypePage", options: { mode: "edit", load: true, onMount: 'collapse' } } },
    // Service Workers (filtered employee view)
    { path: "/service/serviceWorker", element: ListView, props: { type: "serviceWorkerList" } },
    { path: "/service/serviceWorker/:id", element: Page, props: { type: "serviceWorkerPage", options: { mode: "view", load: true } } },
    // Service Technicians
    { path: "/service/serviceTechnician", element: ListView, props: { type: "serviceTechnicianList" } },
    { path: "/service/serviceTechnician/new", element: Page, props: { type: "serviceTechnicianPage", options: { mode: "new", load: false } } },
    { path: "/service/serviceTechnician/:id", element: Page, props: { type: "serviceTechnicianPage", options: { mode: "edit", load: true, onMount: 'collapse' } } },
    // Service Contracts
    { path: "/service/serviceContract", element: ListView, props: { type: "serviceContractList" } },
    { path: "/service/serviceContract/new", element: Page, props: { type: "serviceContractPage", options: { mode: "new", load: false } } },
    { path: "/service/serviceContract/:id", element: Page, props: { type: "serviceContractPage", options: { mode: "edit", load: true, onMount: 'collapse' } } },
    // Service Tickets
    { path: "/service/serviceTicket", element: ListView, props: { type: "serviceTicketList" } },
    { path: "/service/serviceTicket/new", element: Page, props: { type: "serviceTicketPage", options: { mode: "new", load: false } } },
    { path: "/service/serviceTicket/:id", element: Page, props: { type: "serviceTicketPage", options: { mode: "edit", load: true, onMount: 'collapse' } } },
    // Service Work Orders
    { path: "/service/serviceWorkOrder", element: ListView, props: { type: "serviceWorkOrderList" } },
    { path: "/service/serviceWorkOrder/new", element: Page, props: { type: "serviceWorkOrderPage", options: { mode: "new", load: false } } },
    { path: "/service/serviceWorkOrder/:id", element: Page, props: { type: "serviceWorkOrderPage", options: { mode: "edit", load: true, onMount: 'collapse' } } },
    // Time Entries (sub-collection of serviceWorkOrder)
    { path: "/service/serviceWorkOrder/:id/timeEntry/new", element: Page, props: { type: "timeEntryPage", options: { mode: "new", load: false } } },
    { path: "/service/serviceWorkOrder/:id/timeEntry/:id2", element: Page, props: { type: "timeEntryPage", options: { mode: "edit", load: true } } },
    // Service Parts Lines (sub-collection of serviceWorkOrder)
    { path: "/service/serviceWorkOrder/:id/servicePartsLine/new", element: Page, props: { type: "servicePartsLinePage", options: { mode: "new", load: false } } },
    { path: "/service/serviceWorkOrder/:id/servicePartsLine/:id2", element: Page, props: { type: "servicePartsLinePage", options: { mode: "edit", load: true } } }
]

export default routesService
